import type { RetailFeatureConfig } from './RetailFeatureConfig';

/**
 * Only use when absolutely necessary in legacy code
 */
export function dangerouslyMutateFeatureConfig(
    featureConfig: RetailFeatureConfig,
    mutationCallback: (featsConfig: RetailFeatureConfig) => void,
): void {
    mutationCallback(featureConfig);
}
